import { Breadcrumb } from 'antd';
import { __PostBreadcrumbPropsType } from './postBreadcrumb.type';
import { __GenerateCategoryHierarchy } from './postBreadcrumb.script';

export default function PostBreadcrumbComp({ category, categories }: __PostBreadcrumbPropsType) {
    const breadcrumb = __GenerateCategoryHierarchy(category, categories);

    return (
        <Breadcrumb
            items={breadcrumb?.map((i, j) => ({
                title: i.href ? (
                    <a target="_blank" href={i.href}>
                        {j === breadcrumb.length ? (
                            <span className="t-l-black1 t-d-gray3 mr-1">{i.title}</span>
                        ) : (
                            i.title
                        )}
                    </a>
                ) : (
                    i.title
                ),
            }))}
        />
    );
}
